import { render } from "./ForumOutline.vue?vue&type=template&id=55b44d88"
import script from "./ForumOutline.vue?vue&type=script&lang=js"
export * from "./ForumOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__